import type { FC } from 'react';
import React from 'react';
import { MDText } from 'i18n-react';

import { Badge } from '@motorway/mw-highway-code';
import { Input, Toggle } from '@motorway/mw-highway-code/alpha';

import texts from 'Components/VehicleList/VehicleListV2/VehicleListV2.texts.json';
import type { SavedFilter } from 'Types/savedFilter';

import { formatBadgeText } from './formatBadgeText';

import formStyles from '../SavedSearchesFlow.module.scss';

const LocalT = new MDText(texts.savedSearchModals);

interface DeleteViewProps {
	filter?: SavedFilter;
	savedFilterValues?: Array<{ key: string; value: string }>;
}

export const DeleteView: FC<DeleteViewProps> = ({ filter, savedFilterValues }) => (
	<div className={formStyles.formContent}>
		<div className={formStyles.field}>
			<label className={formStyles.label} htmlFor="delete-saved-search-name">
				{`${LocalT.translate('name')}`}
			</label>
			<Input
				disabled
				fullWidth
				formProps={{
					input: {
						readOnly: true,
						type: 'text',
						value: filter?.name || '',
					},
				}}
				id="delete-saved-search-name"
				label={`${LocalT.translate('name')}`}
				showLabel={false}
			/>
		</div>

		{savedFilterValues && savedFilterValues.length > 0 && (
			<div className={formStyles.field}>
				<span className={formStyles.label}>{`${LocalT.translate('criteria')}`}</span>
				<div className={formStyles.badges}>
					{savedFilterValues.map(({ key, value }) => (
						<Badge key={key} text={formatBadgeText(value)} variant="primary" />
					))}
				</div>
			</div>
		)}

		<div className={formStyles.toggleField}>
			<div data-thc-style-override className={formStyles.toggleInfo}>
				<span className={formStyles.label}>{`${LocalT.translate('dailyAlerts')}`}</span>
				<span className={formStyles.toggleDescription}>{`${LocalT.translate('dailyAlertsDescription')}`}</span>
			</div>
			<Toggle
				disabled
				formProps={{
					input: {
						checked: filter?.sendEmailAlert || false,
						name: 'delete-daily-alerts',
						readOnly: true,
						type: 'checkbox',
					},
				}}
				id="delete-daily-alerts-toggle"
				label={`${LocalT.translate('dailyAlerts')}`}
				showLabel={false}
			/>
		</div>
	</div>
);
